export const config = {
  id: 'qa',
  icon: 'Shield',
  color: 'red',
  title: 'QA Engineer',
  description: 'Quality assurance, testing automation, and software quality management',
  department: 'Engineering',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 6,
    mid: 4,
    senior: 3
  }
};
